import { practiceMgrApi, aggregatesSelector } from "@valerahealth/rtk-query"
import { useSelector } from "react-redux"
import { usePatientPreferenceValueOptions } from "../../features"

export function usePatientPreferencesAggregates() {
  const {
    isLoading: isPMAggregatesLoading,
    isError: isPMAggregatesError,
    insurancePlans,
    locations,
  } = practiceMgrApi.useGetPMAggregatesQuery(undefined, {
    selectFromResult: ({ isLoading, isError, data }) => ({
      isLoading,
      isError,
      locations: data?.getLocations,
      insurancePlans: data?.getInsurancePlans || [],
    }),
  })

  const { aggregates, isAggregateError, isAggregateLoading } =
    useSelector(aggregatesSelector)

  const options = usePatientPreferenceValueOptions(
    aggregates,
    locations,
    insurancePlans,
  )

  const isLoading = isPMAggregatesLoading || isAggregateLoading
  const isError = isPMAggregatesError || isAggregateError

  return {
    isLoading,
    isError,
    options,
  }
}
